module.exports = __webpack_public_path__ + "img/md-school.d3f10a76.svg";